import React from 'react';
import { Link } from 'react-router-dom';

const HowItWorksCta: React.FC = () => {
  return (
    <section className="driver-how-cta-section">
      <div className="container">
        <div className="driver-how-cta">
          <div>
            <span className="sw-eyebrow">Need help?</span>
            <h2>ShiftWagon support can guide you.</h2>
            <p>
              If anything feels unclear during onboarding, offers, or a live trip, contact
              ShiftWagon before guessing.
            </p>
          </div>
          <Link className="sw-btn-primary" to="/about#contact">
            Contact ShiftWagon
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksCta;
